import React, {Component} from "react"
import {RouteComponentProps} from "react-router-dom"

import {Team} from "@irati/types"
import teamsService from "@irati/identity/services/teams"
import authentication from "@irati/auth"
import Loading from "@irati/ui/src/Loading"
import TeamList from "../../../components/Teams/TeamList"
import TeamUserList from "../TeamUserList/TeamUserList"

interface Props extends RouteComponentProps {}

interface State {
  currentTeam: Team | null
  load: Promise<any> | null
}

class Teams extends Component<Props, State> {
  state: State = {
    currentTeam: null,
    load: null
  }

  componentDidMount() {
    const teamFromUrl = this.props.location?.state?.teamName
    if (teamFromUrl) {
      const load = teamsService.teamsPaginated(authentication.business().uuid, teamFromUrl).then((teams) => {
        if (teams?.length > 0) {
          this.setState({currentTeam: teams[0]})
        }
      })
      this.setState({load})
    }
  }

  render() {
    const {load, currentTeam} = this.state

    return (
      <Loading load={load}>
        {currentTeam ? (
          <TeamUserList goBack={() => this.setState({currentTeam: null})} team={currentTeam} />
        ) : (
          <TeamList setCurrentTeam={(team) => this.setState({currentTeam: team})} />
        )}
      </Loading>
    )
  }
}

export default Teams
